import { ShapeType } from "../../../types/Enum";


export default function genRandomlyShapeType(prevShapeType?: ShapeType) {
	const shapes = Object.values(ShapeType);
	prevShapeType && shapes.splice(shapes.indexOf(prevShapeType), 1);
	return shapes[Math.floor(Math.random() * shapes.length)]
}